/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ValidateEmailRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {ValidateEmailResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const validateEmailAddress = (request: ValidateEmailRequest, options?: CashRequestOptions) => post<ValidateEmailRequest, ValidateEmailResponse>("/2.0/cash/validate-email-address", request, {...options, rejectOnError: true })